import { IconDefinition, library } from "@fortawesome/fontawesome-svg-core";

export const bookingIcon: IconDefinition = {
  prefix: "fab",
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  iconName: "bookingcom" as any,
  icon: [
    70,
    70,
    [],
    "e001",
    "M23.075 53.232H12.328V40.377c0-2.74 1.054-4.215 3.414-4.51h7.376a8.01 8.01 0 0 1 8.64 8.661c0 5.479-3.309 8.745-8.64 8.745zm-10.768-34.75V15.11c0-2.95 1.264-4.383 4.004-4.552h5.521c4.72 0 7.586 2.824 7.586 7.586 0 3.582-1.939 7.797-7.376 7.797h-9.694zm24.53 12.855l-1.939-1.096 1.686-1.475c1.981-1.686 5.268-5.521 5.268-12.117C41.852 6.533 34.013 0 21.895 0H6.512C2.903.124.032 3.069 0 6.68V64h22.169c13.487 0 22.169-7.334 22.169-18.713 0-6.111-2.803-11.38-7.544-14.014 M47.837 56.308c0-4.278 3.435-7.734 7.692-7.734a7.74 7.74 0 0 1 7.734 7.734c0 4.278-3.456 7.734-7.734 7.734s-7.692-3.456-7.692-7.734",
  ],
};
library.add(bookingIcon);
